import {useSelector} from 'react-redux';

import {selectUserData} from '~/shared/store/storeModules/user';

const useIsB2BUser = (): boolean => {
  const user = useSelector(selectUserData);

  return !!user?.isCompanyUser;
};

export default useIsB2BUser;
